import React from 'react';
const OriginalIcon = (props) => {
    const attribute = Object.assign({}, props);
    const stroke = attribute.stroke || '#4C6AFF';
    delete attribute.stroke;
    return (React.createElement("svg", Object.assign({ width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, attribute),
        React.createElement("path", { d: "M8 9.5H5.5C3.84315 9.5 2.5 10.8431 2.5 12.5V13C2.5 13.5523 2.94772 14 3.5 14H8", stroke: stroke, "stroke-linecap": "round" }),
        React.createElement("circle", { cx: "8", cy: "5", r: "2.5", stroke: stroke }),
        React.createElement("path", { d: "M11 13.6992L9 11.6992M9 11.6992L11 9.69922M9 11.6992L14 11.6992", stroke: stroke, "stroke-linecap": "round", "stroke-linejoin": "round" })));
};
export default OriginalIcon;
